import React, { useEffect } from 'react';
//import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';

import { Toaster } from 'react-hot-toast';


const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)


const Operational = React.lazy(() => import('./views/Operational'));
const Requestor = React.lazy(() => import('./views/Requestor'));
const Tests = React.lazy(() => import('./views/Tests'));


export default function App() {


  useEffect(() => {


  } , [])

  return (
      <BrowserRouter>
        <Toaster />
        <React.Suspense fallback={loading}>
        <div>
          <Routes>
            <Route path="/tests/*" element={<Tests />} />
            <Route path="/o/*" element={<Operational />} />
            <Route path="/r/*" element={<Requestor />} />
            <Route path="*" element={<Navigate to="/r/tickets" replace />}/>
          </Routes>
        </div>
        </React.Suspense>
      </BrowserRouter>
  );
}


